import 'typeface-roboto';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker, { unregister } from './registerServiceWorker';
import { AccountInfo, AuthenticationResult, Configuration, EventMessage, EventType, PublicClientApplication } from '@azure/msal-browser';
import { _clientSettings } from './config/client-settings';

const baseUrl: string = document.getElementsByTagName('base')[0].getAttribute('href');

const msalConfig: Configuration = {
    auth: {
        clientId: _clientSettings.clientId,
        authority: _clientSettings.authority,
        redirectUri: window.location.origin,
        navigateToLoginRequestUrl: false //this property should be true but do to a bug of msal library there would be a login loop
    }
};

export const msalInstance: PublicClientApplication = new PublicClientApplication(msalConfig);

msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const payload: AuthenticationResult = event.payload as AuthenticationResult;
        const account: AccountInfo = payload.account;
        msalInstance.setActiveAccount(account);
    }
});

const accounts: AccountInfo[] = msalInstance.getAllAccounts();

if (accounts.length > 0)
    msalInstance.setActiveAccount(accounts[0]);

ReactDOM.render(
    <App
        baseUrl={baseUrl}
        msalInstance={msalInstance}
        isAccountLogged={accounts.length > 0}
    />,
    document.getElementById('root')
);

// Disable service worker on production
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator)
    unregister();
else
    registerServiceWorker();